export const aracSigortlariPage = () => `
  <section class="page-content service-page">
    <div class="container">
      <div class="service-header">
        <h1 class="page-title">Araç Sigortaları</h1>
        <p class="page-subtitle">Aracınızı her türlü riske karşı koruma altına alıyoruz. 20+ sigorta şirketinden karşılaştırmalı teklif ile en uygun poliçeyi buluyoruz.</p>
      </div>

      <div class="service-list">
        <div class="service-item">
          <div class="service-icon">
            <img src="/icons/trafik_sigorta.png" alt="Trafik Sigortası">
          </div>
          <div class="service-info">
            <h3>Zorunlu Trafik Sigortası</h3>
            <p>Yasal zorunluluk olan trafik sigortası, kazalarda karşı tarafa verilen maddi ve bedeni zararları karşılar. Aracınız trafiğe çıkmadan mutlaka yaptırılması gereken poliçedir.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <img src="/icons/araç kasko.png" alt="Kasko Sigortası">
          </div>
          <div class="service-info">
            <h3>Kasko Sigortası</h3>
            <p>Kendi aracınızın kazada göreceği hasarı, çalınma, yangın ve doğal afet risklerini karşılar. Tam kasko ve dar kasko seçenekleri ile bütçenize uygun teminat sunuyoruz.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <img src="/icons/imm.png" alt="İMM Sigortası">
          </div>
          <div class="service-info">
            <h3>İMM (İhtiyari Mali Mesuliyet)</h3>
            <p>Zorunlu trafik sigortası limitlerinin üzerindeki hasarları karşılayan ek teminat poliçesidir. Büyük kazalarda mali güvencenizi artırır.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
          </div>
          <div class="service-info">
            <h3>Mini Onarım Hizmetleri</h3>
            <p>Küçük çizik, göçük ve boya hasarlarında boyasız göçük düzeltme ve mini onarım hizmetleri ile aracınızı hızlıca eski haline getiriyoruz.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
          </div>
          <div class="service-info">
            <h3>Yol Yardım & Çekici Hizmeti</h3>
            <p>Yolda kaldığınızda 7/24 yol yardım ve çekici hizmeti ile yanınızdayız. Akü takviye, lastik değişim ve yakıt ikmali desteği sunuyoruz.</p>
          </div>
        </div>
      </div>

      <div class="service-cta">
        <h2>Aracınız İçin En Uygun Sigortayı Bulalım</h2>
        <p>Birden fazla sigorta şirketinden karşılaştırmalı teklif alın, en uygun fiyatı yakalayın.</p>
        <a href="/teklif-al" class="btn-primary">Hemen Teklif Al</a>
      </div>
    </div>
  </section>
`;
